import { data, defaults } from "browserslist";
import regeneratorRuntime from "regenerator-runtime";
import axios from "axios";

class H5VP_Video {
  constructor() {
    //let myClass = this;
    this.hlsVideo = [];
    this.dashVideo = [];
    this.quickPlayer();
    this.videoId = null;
    // this.blobURL();
  }

  quickPlayer() {
    if (typeof h5vpData == "undefined") return;
    if (typeof h5vpData.quickPlayer != "undefined") {
      const options = h5vpData.quickPlayer.options;
      if (typeof h5vpI18n != "undefined") {
        options.i18n = h5vpI18n;
      }
      options.controls = this.getControls(options.controls);
      if (typeof h5vpData.globalWorking != "undefined" && h5vpData.globalWorking == 1) {
        setTimeout(() => {
          const video = document.querySelectorAll("video:not(.h5vp_player video):not(a video):not(.h5vp_video_playlist video):not(.plyr__video-wrapper video)");
          const players = Plyr.setup(video, options);
          players &&
            players.map((player) => {
              player.on("ready", () => {
                player.elements.display.duration.innerText = this.toHHMMSS(player.duration);
              });
            });
        }, 100);
      } else {
        const player = Plyr.setup("#h5vp_quick_player", options);
      }
    }
  }

  playWithHTML(options, infos = null) {
    // return false;
    options.controls = this.getControls(options.controls);
    const player = Plyr.setup("video", options);
  }

  disablePause(player) {
    player.on("pause", function () {
      player.play();
    });
    player.on("ended", function () {
      player.source = {
        type: "video",
        sources: [
          {
            src: player.source,
            type: "video/mp4",
            size: 720,
          },
        ],
        poster: player.poster,
      };
    });
  }

  /**
   *
   * @param {string} selector
   * @param {object} options
   * @param {object} infos
   */
  newVideo(wrapperr, optionss = false, infoss = false, editing = false) {
    const $ = jQuery;

    const { wrapper, options, infos, mediaElement } = this.getDetectorData(wrapperr, optionss, infoss);
    if (!wrapper) return false;

    let windowWidth = window.innerWidth;
    // const data = $(wrapper).attr("data-settings");
    const videoId = wrapper.getAttribute("video-id");
    this.videoId = videoId;

    options.seekTime = parseInt(options?.seekTime);
    // console.log(typeof options.seekTime);
    if (typeof h5vpI18n != "undefined") {
      options.i18n = h5vpI18n;
    }

    //Set Controls Base On Device
    options.controls = !Array.isArray(options.controls) ? this.getControls(options.controls) : options.controls;
    // Set quality
    options.quality = {
      default: 576,
      options: [7680, 4320, 3840, 2880, 2560, 2160, 2048, 1920, 1440, 1280, 1080, 768, 720, 640, 576, 432, 480, 360, 240],
    };

    // Create Player Object
    // let mediaElement = "";
    // if (infos?.provider === "library") {
    //   mediaElement = wrapper.querySelector("video");
    // } else {
    //   mediaElement = wrapper.querySelector("div.notlibrary");
    // }

    if (infos?.isCDURL) {
      options.urls = { download: infos?.CDURL };
    }

    const controls = options.controls;
    if (!controls.includes("fullscreen")) {
      options.fullscreen = {
        enabled: false,
      };
    }

    if (typeof hpublic != "undefined" && hpublic?.speed && !options?.speed) {
      let temp = [];
      let speed = [];
      if (typeof hpublic?.speed === "string") {
        temp = hpublic?.speed?.split(",");
      }
      temp.map((item) => {
        speed.push(parseFloat(item));
      });
      options.speed = { selected: 1, options: speed };
    }

    // initialize player
    const player = new Plyr(mediaElement, options);
    // return;

    //orientation
    if (window?.innerWidth < 992) {
      player.on("enterfullscreen", (event) => {
        screen?.orientation?.lock("landscape");
      });

      player.on("exitfullscreen", (event) => {
        screen?.orientation?.lock("portrait");
      });
    }

    player.on("enterfullscreen", function () {
      wrapper.querySelector(".plyr").classList.add("fullscreen");
    });
    player.on("exitfullscreen", (event) => {
      wrapper.querySelector(".plyr").classList.remove("fullscreen");
    });

    //set player exact height
    if (infos?.popup) {
      this.setHeight(wrapper, player);
    }

    // disable pause
    if (infos?.disablePause === true) {
      this.disablePause(player);
    }

    //Count Total Views by post id
    if (infos?.count) {
      this.countViews(player, infos.id);
    }

    // count totla views by video url
    // this.countViewByURL(player);

    // Do Sticky if Sticky is enabled
    if (infos?.sticky && windowWidth > 768 && !infos?.popup) {
      this.doSticky(wrapper, player);
    }

    //Password Controller
    if (infos.protected) {
      this.passwordController(wrapper, player, infos);
    } else {
      this.setSource(wrapper, player, infos);
    }

    // Popup Controler
    if (infos?.popup) {
      this.popupController(wrapper, player);
    }

    //set start time
    // if (infos?.provider === "library" && infos.startTime) {
    //   setTimeout(() => {
    //     player.currentTime = infos.startTime;
    //     console.log("inofs", infos);
    //   }, 500);
    // }

    this.endScreen(wrapper, player, infos);

    //disable other player
    this.disableOtherPlayer(player, false);

    //watermark
    this.watermark(wrapper, player, infos?.watermark || {});

    //autoplay=
    player.on("ready", () => {
      const volume = this.localStorageGetItem(`volume${videoId}`, options?.autoplay || options?.muted ? 0 : 0.5);
      console.log({volume})
      player.volume = volume;
    });

    player.on("volumechange", function () {
      localStorage.setItem(`volume${videoId}`, player.volume);
    });

    if (infos?.thumbInPause) {
      this.thumbInPause(wrapper, player, infos);
    }

    //hide icon
    if (infos?.provider !== "library") this.hideYoutubeVimeoIcon(wrapper, player);

    player.on("ready", () => {
      // set duration if missing
      if (typeof player.elements.display.duration !== "undefined") {
        player.elements.display.duration.innerText = this.toHHMMSS(player.duration);
      }

      if (wrapper.getAttribute("data-settings")) {
        wrapper.removeAttribute("data-settings");
      }

      if (!infos?.video?.poster) this.getThumbnailFromSource({ player, time: infos?.posterTime || 20, wrapper });

      setTimeout(() => {
        if (infos?.startTime) {
          player.currentTime = infos.startTime;
        } else {
          // const currentTime = localStorage.getItem(`video-progress-${videoId}`);
          // const thumbTime = player?.duration > 1000 ? 5 : player.duration > 500 ? 2 : 0.45;
          const currentTime = this.localStorageGetItem(`video-progress-${videoId}`, 0);
          player.currentTime = parseFloat(currentTime);
        }
        player.on("timeupdate", function () {
          localStorage.setItem(`video-progress-${videoId}`, player.currentTime);
        });
      }, 500);

      player.media.setAttribute("preload", "metadata");
    });
    //create chapter
    setTimeout(() => {
      if (infos?.chapters?.length) {
        this.createChapter(wrapper, player, infos?.chapters);
      }
    }, 1000);

    // player.on("ready", function () {
    //   console.log("duration", player.duration);
    // });

    player.on("pause", () => {
      !document.hidden && !editing && this.createView(player, videoId, infos?.provider);
    });

    setInterval(() => {
      !document.hidden && !editing && this.createView(player, videoId, infos?.provider, true);
    }, 10000);

    return player;
  }

  createChapter(wrapper, player, chapters) {
    if (!chapters) {
      return false;
    }
    const progressContainer = wrapper.querySelector(".plyr__progress__container");
    const chapterWrapper = document.createElement("div");
    const chapterListWrapper = document.createElement("div");
    const chapterButton = document.createElement("button");
    const chapterList = document.createElement("div");

    chapterButton.classList = "h5vp-chapter-button plyr__controls__item plyr__control";
    chapterButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.3 487.3"> <path d="M487.2,69.7c0,12.9-10.5,23.4-23.4,23.4h-322c-12.9,0-23.4-10.5-23.4-23.4s10.5-23.4,23.4-23.4h322.1 C476.8,46.4,487.2,56.8,487.2,69.7z M463.9,162.3H141.8c-12.9,0-23.4,10.5-23.4,23.4s10.5,23.4,23.4,23.4h322.1 c12.9,0,23.4-10.5,23.4-23.4C487.2,172.8,476.8,162.3,463.9,162.3z M463.9,278.3H141.8c-12.9,0-23.4,10.5-23.4,23.4 s10.5,23.4,23.4,23.4h322.1c12.9,0,23.4-10.5,23.4-23.4C487.2,288.8,476.8,278.3,463.9,278.3z M463.9,394.3H141.8 c-12.9,0-23.4,10.5-23.4,23.4s10.5,23.4,23.4,23.4h322.1c12.9,0,23.4-10.5,23.4-23.4C487.2,404.8,476.8,394.3,463.9,394.3z M38.9,30.8C17.4,30.8,0,48.2,0,69.7s17.4,39,38.9,39s38.9-17.5,38.9-39S60.4,30.8,38.9,30.8z M38.9,146.8 C17.4,146.8,0,164.2,0,185.7s17.4,38.9,38.9,38.9s38.9-17.4,38.9-38.9S60.4,146.8,38.9,146.8z M38.9,262.8 C17.4,262.8,0,280.2,0,301.7s17.4,38.9,38.9,38.9s38.9-17.4,38.9-38.9S60.4,262.8,38.9,262.8z M38.9,378.7 C17.4,378.7,0,396.1,0,417.6s17.4,38.9,38.9,38.9s38.9-17.4,38.9-38.9C77.8,396.2,60.4,378.7,38.9,378.7z"/> </svg><span class="plyr__tooltip">Chapter</span>`;
    chapterWrapper.classList = "h5vp-chapter-wrapper";
    chapterListWrapper.classList = "h5vp-chapter-list-wrapper";
    chapterList.classList = "h5vp-chapter-list";

    const volumeElem = wrapper.querySelector(".plyr__controls__item.plyr__volume");
    const menu = wrapper.querySelector(".plyr__controls__item.plyr__menu");
    const fullscreen = wrapper.querySelector(".plyr__controls__item[data-plyr='fullscreen']");
    const duration = wrapper.querySelector(".plyr__controls__item.plyr__time--current.plyr__time");

    if (volumeElem) {
      volumeElem.before(chapterButton);
    } else if (menu) {
      menu.before(chapterButton);
    } else if (fullscreen) {
      fullscreen.before(chapterButton);
    } else if (duration) {
      duration.before(chapterButton);
    }
    // player.on("ready", () => {
    // setTimeout(() => {
    chapters.map((chapter) => {
      if (chapter?.name != "" && chapter?.time != "") {
        const time = this.chapterTimeToSeconds(chapter?.time);
        const left = (time / player.duration) * 100;
        const chapterElement = document.createElement("div");
        const chapterItem = document.createElement("button");

        chapterElement.innerHTML = `<span class="h5vp-chapter-name plyr__tooltip" role="tooltip">${chapter?.name}</span>`;
        chapterElement.classList = "h5vp-chapter-marker plyr__controls__item plyr__control";
        chapterElement.style.left = `calc(${left}% - ${this.getTTT(5, left)}px)`;

        //chapter item
        chapterItem.innerHTML = `<span>${chapter?.name}</span>`;

        chapterWrapper.appendChild(chapterElement);
        chapterList.appendChild(chapterItem);

        chapterElement.onclick = () => {
          player.currentTime = time;
          player.play();
        };

        chapterItem.onclick = () => {
          chapterList.classList.remove("showing");
          player.currentTime = time;
          player.play();
        };

        chapterButton.onclick = () => {
          if (chapterList.classList.contains("showing")) {
            chapterList.classList.remove("showing");
          } else {
            chapterList.classList.add("showing");
          }
        };

        wrapper.addEventListener("click", function (event) {
          if (!chapterList.contains(event.target) && !chapterButton.contains(event.target)) {
            if (chapterList.classList.contains("showing")) {
              chapterList.classList.remove("showing");
            }
          }
        });

        this.onClick(wrapper.querySelector(".plyr__controls__item.plyr__menu button"), function () {
          if (chapterList.classList.contains("showing")) {
            chapterList.classList.remove("showing");
          }
        });
      }
    });

    // jQuery.on("click", function () {});

    progressContainer.appendChild(chapterWrapper);
    chapterListWrapper.appendChild(chapterList);
    wrapper.querySelector(".plyr__controls").after(chapterListWrapper);
  }

  getTTT(f = 10, s = 10) {
    return (f / 100) * s - (f / 100) * (100 - s);
  }

  onClick(element, callback) {
    if (element) {
      element.onclick = () => callback();
    }
  }

  /**
   *
   * @param {String} value
   */
  chapterTimeToSeconds(value = "") {
    const time = value.match(/(\d+):(\d+)/);
    if (time == null) {
      return parseInt(value);
    }
    return parseInt(time[1]) * 60 + parseInt(time[2]);
  }

  /**
   *
   * @param {media player} player
   * @param {int} videoId
   * @param {string} type
   * @param {boolean} interval
   */
  createView(player, videoId, type = "library", interval = false) {
    let pending = false;
    const currentTime = parseInt(localStorage.getItem(`video-progress-${videoId}`));
    let maxViewed = localStorage.getItem(`video-progress-max-${videoId}`);
    let created_at = new Date();

    if (!maxViewed) {
      localStorage.setItem(`video-progress-max-${videoId}`, JSON.stringify({ currentTime, created_at }));
    } else {
      maxViewed = JSON.parse(maxViewed);
    }

    const viewCreated = (created_at - new Date(maxViewed?.created_at)) / (1000 * 60);
    let condition = false;
    if (interval) {
      condition = player.playing && (currentTime >= maxViewed?.currentTime || viewCreated > 1440);
    } else {
      condition = currentTime >= maxViewed?.currentTime || viewCreated > 1440;
    }

    if (condition) {
      if (viewCreated > 1440) {
        maxViewed.created_at = created_at;
      }
      maxViewed.currentTime = player.currentTime;
      localStorage.setItem(`video-progress-max-${videoId}`, JSON.stringify(maxViewed));
      if (!pending) {
        pending = true;
        axios
          .post(hpublic?.siteUrl || h5vpBlock?.siteUrl + "/wp-json/h5vp/v1/view", {
            duration: parseInt(player.currentTime),
            video_id: videoId,
            user_id: hpublic?.userId || h5vpBlock?.userId,
            type: type,
          })
          .then(function (response) {
            // console.log("response", response);
            pending = false;
          });
      }
    }
  }

  /**
   * Count total views
   * @param {player object} player
   * @param {int} id
   */
  countViews(player, id) {
    let i = 0;
    player.on("play", (event) => {
      if (i < 1) {
        jQuery.post(
          h5vpData.ajax_url,
          {
            action: "video_played",
            data: 1,
            id: id,
          },
          function (data) {}
        );
      }
      i++;
    });
  }

  /**
   * Do sticky if sticky is enabeld
   * @param {player object} player
   * @param {int} id
   */
  doSticky(wrapper, player) {
    let $ = jQuery;
    wrapper = $(wrapper);
    let sticky;
    let videoHeight = 450;
    setTimeout(() => {
      if (typeof wrapper.find("video")[0] !== "undefined") {
        videoHeight = wrapper.height() ? wrapper.height() : 450;
      }
    }, 1000);
    $(window).on("scroll", function () {
      if (player.playing == true) {
        sticky = parseInt(wrapper.find(".plyr--playing").parent().offset().top);
        if (parseInt(window.pageYOffset - 100) > sticky) {
          wrapper.find(".plyr--playing").addClass("video-sticky in");
          wrapper.find(".plyr--playing").parent().find(".sticky_close").show();
          setTimeout(() => {
            wrapper.height(videoHeight);
          }, 1100);
          wrapper
            .find("button[data-plyr=restart],button[data-plyr=fast-forward], button[data-plyr=pip],a[data-plyr=download],button[data-plyr=settings], button[data-plyr=rewind]")
            .hide();
        } else {
          wrapper.height("initial");
          wrapper.find(".plyr--playing").removeClass("video-sticky in");
          wrapper.find(".sticky_close").hide();
          wrapper
            .find("button[data-plyr=restart],button[data-plyr=fast-forward], button[data-plyr=pip],a[data-plyr=download],button[data-plyr=settings], button[data-plyr=rewind]")
            .show();
        }
      }
      if (parseInt(window.pageYOffset + 100) < sticky) {
        wrapper.height("initial");
        wrapper.find(".plyr--playing").removeClass("video-sticky in");
        wrapper.find(".plyr--paused").removeClass("video-sticky in");
        wrapper.find(".sticky_close").hide();
        wrapper
          .find("button[data-plyr=restart],button[data-plyr=fast-forward], button[data-plyr=pip],a[data-plyr=download],button[data-plyr=settings], button[data-plyr=rewind]")
          .show();
      }
    });

    wrapper.find(".sticky_close").on("click", function () {
      wrapper.find(".plyr").removeClass("video-sticky in");
      wrapper
        .find("button[data-plyr=restart],button[data-plyr=fast-forward], button[data-plyr=pip],a[data-plyr=download],button[data-plyr=settings], button[data-plyr=rewind]")
        .show();
      player.pause();
      $(this).hide();
    });

    wrapper.parents(".et_pb_column").css("z-index", "999999999");
  }
  /**
   *
   * @param {object} player
   * @param {object} infos
   */
  passwordController(wrapper, player, infos) {
    let myClass = this;
    let $ = jQuery;
    wrapper = $(wrapper);

    wrapper.find(".password_form form").on("submit", function (e) {
      e.preventDefault();
      let newThis = this;
      let form = $(newThis).parent();
      let overlay = $(newThis).parent().parent().find(".video_overlay");
      const password = myClass.scramble("decode", infos?.propagans);
      const givenPassword = $(this).find("#password").val();
      if (password === givenPassword) {
        $(newThis).find(".notice").addClass("success").text("Success");
        $(newThis).find(".notice").fadeIn();
        setTimeout(() => {
          form.hide();
          overlay.hide();
        }, 1000);
        infos.video.source = myClass.scramble("decode", infos?.video?.source);
        myClass.setSource(wrapper, player, infos);
        return false;
      } else {
        $(newThis).find(".notice").addClass("error").text("Wrong Password");
        setTimeout(() => {
          $(newThis).find(".notice").fadeOut();
        }, 1000);
      }
    });
  }

  /**
   *
   * @param {array with object} VideoQuality
   */
  getQuality(VideoQuality) {
    if (typeof VideoQuality === "object" && VideoQuality !== null) {
      let V = [];
      let length = VideoQuality.length;
      for (let i = 0; i < length; i++) {
        V[i] = {
          src: VideoQuality[i].video_file,
          size: VideoQuality[i].size,
          type: "video/mp4",
        };
      }
      return V;
    }
  }

  /**
   *
   * @param {string} subtitle
   */
  getSubtitle(subtitle) {
    if (typeof subtitle === "object" && subtitle !== null) {
      let videoSubtitle = [];
      let length = subtitle.length;
      for (let i = 0; i < length; i++) {
        if (subtitle[i].label == "") continue;
        videoSubtitle[i] = {
          kind: "captions",
          label: subtitle[i].label,
          src: subtitle[i].caption_file,
          srclang: subtitle[i].label,
        };
        if (i === 0) {
          videoSubtitle[i].default = true;
        }
      }
      return videoSubtitle;
    }
  }

  /**
   *
   * @param {object} oldControls
   */
  getControls(oldControls) {
    let windowWidth = window.innerWidth;
    let controls = [];
    for (let [key, value] of Object.entries(oldControls)) {
      if ((value == "show" || value == "mobile") && windowWidth > 576) {
        controls.push(key);
      } else if (value != "mobile" && value != "hide" && windowWidth < 576) {
        controls.push(key);
      }
    }
    return controls;
  }

  /**
   *
   * @param {object} player
   * @param {object} infos
   */
  setSource(wrapper, media, infos, resolution = 720) {
    const $ = jQuery;
    const thisClass = this;
    if (!infos.streaming) {
      if (infos?.provider == "library") {
        let VideoQuality = this.getQuality(infos?.video?.quality) ? this.getQuality(infos?.video?.quality) : [];
        let subtitle = this.getSubtitle(infos?.video?.subtitle) ? this.getSubtitle(infos?.video?.subtitle) : [];

        const blobURL = async () => {
          let objUrl = null;
          const result = await fetch(infos?.video?.source);
          const blob = await result.blob();
          objUrl = URL.createObjectURL(blob);
          // disable context menu
          // jQuery(document).contextmenu(function (e) {
          //   e.preventDefault();
          // });

          // disable ctrl, alt, shift, f12
          // document.onkeydown = function (e) {
          //   if (e.ctrlKey || e.shiftKey || e.altKey || e.key === "F12") {
          //     return false;
          //   } else {
          //     return true;
          //   }
          // };

          media.source = {
            type: "video",
            sources: [{ src: objUrl, type: "video/mp4", size: resolution }, ...VideoQuality],
            poster: infos.video.poster,
            tracks: subtitle,
          };

          // setTimeout(() => {
          //   URL.revokeObjectURL(objUrl);
          // }, 1000);

          return objUrl;
        };
        if (false) {
          // this.detectDevTool();
          blobURL();
        } else {
          if (infos?.video?.source) {
            VideoQuality.push({ src: infos?.video?.source, type: "video/mp4", size: 720 });
          }
          media.source = {
            type: "video",
            sources: [...VideoQuality],
            poster: infos?.video?.poster,
            tracks: subtitle,
          };
        }
      } else if (infos.provider == "youtube") {
        media.source = {
          type: "video",
          sources: [{ src: infos?.video?.source, provider: "youtube" }],
          poster: infos?.video?.poster,
        };
      } else if (infos.provider == "vimeo") {
        media.source = {
          type: "video",
          sources: [{ src: infos?.video?.source, provider: "vimeo" }],
          poster: infos?.video?.poster,
        };
      }
    } else {
      if (infos?.streamingType == "hls") {
        this.videoHls(wrapper, media, infos);
      } else if (infos?.streamingType == "dash") {
        this.videoDash(wrapper, media, infos);
      }
    }

    if (infos?.captionEnabled && media.captions.currentTrack === -1) {
      // const plyrSettings = this.localStorageGetItem("plyr");
      setTimeout(() => {
        media.toggleCaptions();
      }, 1000);
      // if (plyrSettings?.captions !== false) {
      // }
    }

    // console.log('custom thumb', infos?.FYT)
    // if(infos?.FYT){
    //   console.log(infos?.video?.poster)
    //   media.on('ready', function(){

    //     $(wrapper).find('.plyr__video-embed .plyr__poster').css("display",  `none`)
    //   })
    // }
  }

  videoHls(wrapper, player, infos) {
    if (!Hls.isSupported()) {
    } else {
      const video = wrapper.querySelector("video");
      // For more Hls.js options, see https://github.com/dailymotion/hls.js
      const hls = new Hls();
      hls.loadSource(infos.video.source);
      hls.attachMedia(video);
      player.on("languagechange", () => {
        setTimeout(() => (hls.subtitleTrack = player.currentTrack), 50);
      });
    }
  }

  videoDash(wrapper, player, infos) {
    const videos = wrapper.querySelectorAll("video");
    let length = videos.length;
    for (let i = 0; i < length; i++) {
      const dash = dashjs.MediaPlayer().create();
      dash.initialize(videos[i], infos.video.source, true);
    }
  }

  detectDevTool() {
    if (window.attachEvent) {
      if (document.readyState === "complete" || document.readyState === "interactive") {
        this.devetoolDetecter();
        window.attachEvent("onresize", this.devetoolDetecter);
        window.attachEvent("onmousemove", this.devetoolDetecter);
        window.attachEvent("onfocus", this.devetoolDetecter);
        window.attachEvent("onblur", this.devetoolDetecter);
      } else {
        setTimeout(argument.callee, 0);
      }
    } else {
      window.addEventListener("load", this.devetoolDetecter);
      window.addEventListener("resize", this.devetoolDetecter);
      window.addEventListener("mousemove", this.devetoolDetecter);
      window.addEventListener("focus", this.devetoolDetecter);
      window.addEventListener("blur", this.devetoolDetecter);
    }
  }

  devetoolDetecter(allow) {
    if (isNaN(+allow)) allow = 100;
    var start = +new Date();
    debugger;
    var end = +new Date();
    if (isNaN(start) || isNaN(end) || end - start > allow) {
      alert("DEVTOOLS detected. all operations will be terminated.");
      document.write("DEVTOOLS detected.");
    }
  }

  scramble(task = "encode", data = "") {
    const originalKey = "abcdefghijklmnopqrstuvwxyz1234567890";
    const key = "z1ntg4ihmwj5cr09byx8spl7ak6vo2q3eduf";
    let resultData = "";
    if (task == "encode") {
      if (data != "") {
        const length = data.length;
        for (let i = 0; i < length; i++) {
          const position = originalKey.indexOf(data[i]);
          if (position !== -1) {
            resultData += key[position];
          } else {
            resultData += data[i];
          }
        }
      }
    }

    if (task == "decode") {
      if (data != "") {
        const length = data.length;
        for (let i = 0; i < length; i++) {
          const currentChar = data[i];
          const position = key.indexOf(currentChar);
          if (position !== -1) {
            resultData += originalKey[position];
          } else {
            resultData += currentChar;
          }
        }
      }
    }
    return resultData;
  }

  /**
   *
   * @param {Wrapper} wrapper
   * @param {Object} media
   */
  popupController(wrapper, media) {
    const $ = jQuery;
    const jWrapper = $(wrapper);
    const popupOpener = wrapper.querySelector(".h5vp_popup svg");
    const popupCloser = wrapper.querySelector(".popup_close_btn");
    const playerWrapper = wrapper.querySelector(".plyr");
    popupOpener.addEventListener("click", function () {
      wrapper.classList.add("popup_open");
      wrapper.classList.remove("popup_close");
      popupCloser.style.display = "block";
      media.play();
    });
    popupCloser.addEventListener("click", function () {
      popupCloser.style.display = "none";
      wrapper.classList.remove("popup_open");
      wrapper.classList.add("popup_close");
      media.pause();
    });
  }

  countViewByURL(player) {
    let i = 0;
    player.on("play", (event) => {
      // console.log("player soruce", this.blobToNormal(player.source));
      // if (i < 1) {
      //   jQuery.post(
      //     h5vpData.ajax_url,
      //     {
      //       action: "video_played",
      //       data: 1,
      //       id: id,
      //     },
      //     function (data) {}
      //   );
      // }
      // i++;
    });
  }

  blobToNormal(blobUrl) {
    // var blob = new Blob(["Hello, world!"], { type: "text/plain" });
    // var blobUrl = URL.createObjectURL(blob);
    var xhr = new XMLHttpRequest();
    xhr.responseType = "blob";

    xhr.onload = function () {
      var recoveredBlob = xhr.response;

      var reader = new FileReader();

      reader.onload = function () {
        var blobAsDataUrl = reader.result;
        window.location = blobAsDataUrl;
      };

      reader.readAsDataURL(recoveredBlob);
    };

    xhr.open("GET", blobUrl);
    xhr.send();
  }

  hideYoutubeVimeoIcon(wrapper, player) {
    player.on("ready", function () {
      const icon = wrapper.querySelector(".plyr__controls a[data-plyr='download']");
      if (icon) icon.style.display = "none";
    });
  }

  /**
   *
   * @param {*} player
   */
  disableOtherPlayer(player, play = true) {
    const $ = jQuery;
    const players = $("video");
    players.each(function () {
      $(this)[0].pause();
    });

    if (play) {
      player?.play();
    } else {
      player?.pause();
    }
  }

  setHeight(wrapper, media) {
    const wrapperWidth = jQuery(wrapper).width();
    media.on("loadeddata", function () {
      const str = media.ratio;
      if (!str) return false;
      const [r1, r2] = str.split(":");
      const height = (wrapperWidth / r1) * r2;
      jQuery(wrapper)
        .find(".h5vp_popup ")
        .css("height", height + "px");
    });
  }

  thumbInPause(wrapper, player, infos) {
    const $ = jQuery;
    //only for one persion.
    // if(infos?.provider !== 'library' && infos?.thumbInPause){

    if (infos?.thumbStyle == "custom") {
      const img = document.createElement("img");
      img.src = infos?.video?.poster;
      player.on("ready", function () {
        const poster = wrapper.querySelector(".plyr__poster");
        $(wrapper).find(".plyr__control--overlaid").addClass("thumbInPause");
        // $(wrapper).find(".plyr__controls").hide();
        $(wrapper).find(".plyr__control--overlaid").append(img);
      });
      player.on("seeked", () => {
        img.style.display = "none";
        setTimeout(() => {
          img.style.display = "block";
        }, 500);
      });
    } else {
      player.on("ready", function () {
        setTimeout(() => {
          const poster = wrapper.querySelector(".plyr__poster");
          if (poster && !player.playing) poster.style.opacity = 1;
          player.on("pause", function () {
            if (poster) poster.style.opacity = 1;
          });
          player.on("play", function () {
            if (poster) poster.style.opacity = 0;
          });
        }, 50);
      });
    }
  }

  endScreen(wrapper, player, infos) {
    const $ = jQuery;
    const html = `<div id="h5vp_endscreen">
                      <div class="overlay"></div>
                      <div class="endscreen_content">
                          <button><span>&#128065;</span> Watch Again</button>
                          <p><a href="${infos?.endscreen_text_link}">${infos?.endscreen_text}</a></p>
                      </div>
                  </div>`;
    $(wrapper).find(".plyr").append(html);
    if (infos?.endscreen) {
      player.on("ended", (event) => {
        player.pause();
        $(wrapper).find("#h5vp_endscreen").fadeIn();
      });
      $(wrapper)
        .find(".endscreen_content button")
        .on("click", function () {
          $(wrapper).find("#h5vp_endscreen").fadeOut();
          player.play();
        });
    }
  }
  /**
   *
   * @param {*} time
   * @returns
   */
  toHHMMSS(time) {
    var sec_num = parseInt(time, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return minutes + ":" + seconds;
  }

  getDetectorData(wrapper, options, infos) {
    let mediaElement = null;
    let canvas = null;

    // get the exact wrapper
    if (wrapper === null) {
      return false;
    }
    if (typeof wrapper[0] !== "undefined") {
      wrapper.map((index, item) => {
        this.newVideo(item, options, infos);
      });
      return false;
    }
    if (typeof wrapper.length !== "undefined" && wrapper.length === 0) {
      return false;
    }
    if (wrapper.querySelector(".h5vp_player") !== null) {
      wrapper = wrapper.querySelector(".h5vp_player");
    }

    //get data from attribute if it not pass in function
    let settings = jQuery(wrapper).attr("data-settings");
    if (settings) {
      settings = JSON.parse(settings);
      if (!options) {
        options = settings?.options;
      }
      if (!infos) {
        infos = settings?.infos;
      }
    }

    if (infos?.provider === "library") {
      mediaElement = wrapper.querySelector("video");
    } else {
      mediaElement = wrapper.querySelector("div.notlibrary");
    }

    // canvas = wrapper.querySelector(".video_thumbnails");

    return {
      wrapper,
      options,
      mediaElement,
      infos,
    };
  }

  localStorageGetItem(key, defaultValue = null) {
    let output;
    const value = localStorage.getItem(key);
    if (value) {
      try {
        output = JSON.parse(value);
      } catch (error) {
        output = value;
      }
      return output;
    }
    return defaultValue;
  }

  getThumbnailFromSource({ player, time, wrapper }) {
    const videoId = this.videoId;
    const canvas = document.createElement("canvas");
    const videoWrapper = wrapper.querySelector(".plyr__video-wrapper");
    const plyrIoWrapper = wrapper.querySelector(".plyr");
    const oldPoster = videoWrapper.querySelector(".plyr__poster");
    oldPoster.classList.remove("plyr__poster");
    canvas.classList.add("plyr__poster");
    plyrIoWrapper.classList.add("plyr__poster-enabled");
    const ctx = canvas.getContext("2d");

    const video = document.createElement("video");
    video.src = player.source;
    video.load();

    video.currentTime = parseFloat(time);
    videoWrapper.appendChild(canvas);

    setTimeout(() => {
      canvas.width = videoWrapper.offsetWidth;
      canvas.height = videoWrapper.offsetHeight;
    }, 100);

    setTimeout(() => {
      ctx.drawImage(video, 0, 0, videoWrapper.offsetWidth, videoWrapper.offsetHeight);
    }, 1000);
  }

  watermark(wrapper, player, watermark) {
    const { enabled, type, text, color } = watermark;
    const plyrWrapper = wrapper.querySelector(".plyr");
    if (enabled) {
      let content = text;
      if (type === "email") {
        content = h5vpData?.user?.email;
      } else if (type === "name") {
        content = h5vpData?.user?.name;
      }
      let tag = "watermark";
      player.on("play", function () {
        window.watermarkInterval = setInterval(() => {
          const watermarkElement = document.querySelector(tag);
          if (watermarkElement) {
            plyrWrapper.removeChild(watermarkElement);
          }
          tag = "watermark" + Math.round(Math.random() * 1000);
          const span = document.createElement(tag);
          span.setAttribute("style", "display: block !important");
          if (type === "email") {
            span.innerText = content;
          }
          plyrWrapper.appendChild(span);
          setTimeout(() => {
            span.innerText = content;
            span.setAttribute(
              "style",
              `position:absolute; display:block !important; opacity:1 !important;top: ${Math.round(Math.random() * 90)}% !important; left: ${Math.round(
                Math.random() * 70
              )}% !important; transform: none !important`
            );
            span.style.color = color;
            plyrWrapper.appendChild(span);
          }, 0);
        }, 2000);
      });

      player.on("pause", function () {
        clearInterval(window.watermarkInterval);
        const watermarkElement = document.querySelector(tag);
        if (watermarkElement) {
          plyrWrapper.removeChild(watermarkElement);
        }
      });
    }
  }
}

export default H5VP_Video;

// export const blobURL = async (url, type) => {
//   // let blob = new Blob(["http://localhost/freemius/wp-content/uploads/2020/11/big_buck_bunny.mp4"], { type: "video/ogg" });
//   // const blobUrl = (URL || webkitURL).createObjectURL(blob);
//   // const video = document.querySelector("video");
//   // // video.style.display = none;
//   // video.src = blobUrl;
//   let objUrl = null;

//   const result = await fetch("http://localhost/freemius/wp-content/uploads/2020/11/big_buck_bunny.mp4");
//   const blob = await result.blob();
//   objUrl = URL.createObjectURL(blob);
//   alert(objUrl);
//   return objUrl;
// };
